import { createAction, props } from '@ngrx/store';

export const ErrorReceived = createAction(
  '[Error] Error Received',
  props<{ error: TypeError }>()
);

export const ClearError = createAction('[Error] Clear Error');
